import * as React from "react"
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"

// The template's collapsible (next-shadcn-admin-dashboard/src/components/ui/
// collapsible.tsx at bff60d4), every class unchanged, ported by a script: Helix's
// Radix import, and React's types imported rather than read as a global.
// Record: docs/testing/ui-migration/017-ui-collapsible.md.

function Collapsible({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />
}

function CollapsibleTrigger({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      {...props}
    />
  )
}

function CollapsibleContent({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot="collapsible-content"
      {...props}
    />
  )
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
